<template>
  <div
    class="d-flex bg-light fill-page justify-content-center align-items-center"
  >
    <slot>
      <router-view />
    </slot>
  </div>
</template>

<script>
export default {
  name: "AlzataModalLayout",
};
</script>
